import { useEffect } from 'react';
import { DialogContent } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { useConnectBankMutation } from '../../../api/gql';
import { FullSizeLoader } from '../../../components/FullSizeLoader';
import { useSafeNavigation } from '../../../hooks/useSafeNavigation';
import { notify } from '../../../utils/notification';

export const ConnectBankPage = () => {
  const { paymentProvider } = useParams();
  const { t } = useTranslation('bank-connection');
  const { safeNavigate } = useSafeNavigation();
  const { mutate: connectBank } = useConnectBankMutation({
    onSuccess: (data) => {
      window.location.href = data.connectBank.redirectUrl;
    },
    onError: (e) => {
      console.error(e);
      notify.negative({ message: t('bankConnection.mutation.error') });
      safeNavigate('/bank-connection');
    },
  });

  useEffect(() => {
    if (!paymentProvider) {
      return;
    }
    connectBank({
      input: {
        callbackUrl: `${window.location.origin}/bank-connection`,
        paymentProvider: paymentProvider,
      },
    });
  }, [connectBank, paymentProvider]);

  return (
    <DialogContent sx={{ minHeight: 300, minWidth: 300 }}>
      <FullSizeLoader />
    </DialogContent>
  );
};
